import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from '../components/common/Banner';
import AboutContent from '../components/about/AboutContent';
import FounderSection from '../components/about/FounderSection';
import MissionVision from '../components/about/MissionVision';
import WhyChooseUs from '../components/about/WhyChooseUs';
import TeamSection from '../components/about/TeamSection';
import Achievements from '../components/about/Achievements';

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About Us - KALS Academy</title>
        <meta name="description" content="Learn about KALS Academy, our founder C. Kalyanasundaram, our mission, vision, values, team, and achievements in the field of structural engineering education." />
      </Helmet>
      
      <Banner title="About KALS Academy" />
      <AboutContent />
      <FounderSection />
      <MissionVision />
      <WhyChooseUs />
      <TeamSection />
      <Achievements />
    </>
  );
};

export default AboutPage;
